import CardPin from 'components/CardPin'
import { recaptchaKey } from 'configs'
import { validateEmail } from 'helpers'
import useRecaptchaV3 from 'hooks/useRecaptchaV3'
import { SetPinModal } from 'ModalHome/SetPinModal'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { login } from '../login/loginSlice'
import {
  useLoginUserNewMutation,
  useResetPinMutation,
  useSendOtpLoginMutation,
  useVerifyOtpLoginMutation,
  useVerifyPINOtpMutation,
} from './loginNewApiSlice'

const Otp = () => {
  const recaptcha = useRecaptchaV3(recaptchaKey)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { token } = useSelector((s) => s.auth)
  const dataState = location.state
  const countdownInterval = useRef(null)
  const [isAction, setIsAction] = useState(false)
  const [countdown, setCountdown] = useState(Number(dataState?.countDown) ?? 60)
  const [errMsg, setErrMsg] = useState('')
  const [isSetPin, setIsSetPin] = useState(false)
  const [otp, setOtp] = useState('')
  const [loadingFetchOtp, setLoadingFetchOtp] = useState(false)

  const [verifyOtp] = useVerifyOtpLoginMutation()
  const [verifyPINOtp] = useVerifyPINOtpMutation()
  const [resetPin] = useResetPinMutation()
  const [sendOtp] = useSendOtpLoginMutation()
  const { enqueueSnackbar } = useSnackbar()
  const [loginUser] = useLoginUserNewMutation()

  const browserHashLocalStorage = localStorage.getItem('browserHash')
  const browserFingerPrintLocalStorage =
    localStorage.getItem('browserFingerPrint')
  const browserCustomFingerPrintLocalStorage = localStorage.getItem(
    'browserCustomFingerPrint',
  )

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      .grecaptcha-badge {
        left: auto !important;
        top: 0 !important;
        bottom: auto !important;
        z-index: 9999 !important;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])

  const startCountdown = (time) => {
    setCountdown(time)
    if (countdownInterval.current) {
      clearInterval(countdownInterval.current)
    }

    countdownInterval.current = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(countdownInterval.current)
          return 0
        }
        return prevCountdown - 1
      })
    }, 1000)
  }

  const handleSubmit = async (enteredPin) => {
    try {
      setOtp(enteredPin)
      setErrMsg('')
      setIsAction(true)
      let res

      let payload = {
        identity: dataState?.identity,
        deviceHash: dataState?.deviceHash,
        type: dataState?.status ? dataState?.status : 'registration',
        otp: enteredPin,
        browserHash: browserHashLocalStorage ?? dataState?.browserHash,
        browserFingerPrint:
          browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
        browserCustomFingerPrint:
          browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
        'g-recaptcha-response': await recaptcha(),
      }
      if (dataState?.type === 'resetPin') {
        res = await verifyPINOtp(payload)
      } else {
        res = await verifyOtp(payload)
      }
      if (!res?.error) {
        if (dataState?.status?.toLowerCase() === 'login') {
          const loginPayload = {
            identity: dataState?.identity,
            deviceHash: dataState?.deviceHash,
            password: dataState.password,
            fcmToken: dataState?.fcmToken ?? '',
            packageName: dataState?.packageName || localStorage.getItem('PMB_packageName') || null,
            version: ` ${dataState?.mobileVersion ? `PM ${process.env.REACT_APP_VERSION} (${dataState?.mobileVersion})` : `PMB ${process.env.REACT_APP_VERSION}`} `,
            browserHash: browserHashLocalStorage ?? dataState?.browserHash,
            browserFingerPrint:
              browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
            browserCustomFingerPrint:
              browserCustomFingerPrintLocalStorage ??
              dataState?.browserCustomFingerPrint,
            'g-recaptcha-response': await recaptcha(),
          }
          const res = await loginUser(loginPayload)
          if (!res?.error) {
            dispatch(
              login({
                identity: dataState?.identity,
                'g-recaptcha-response': await recaptcha(),
                ...res?.data,
              }),
            )
            // window.location.replace('/homepage')
            window.location.replace('/')
          } else {
            throw res
          }
        } else {
          if (dataState?.type === 'resetPin') {
            setIsSetPin(true)
          } else {
            navigate('/register', { state: { ...dataState, otp: enteredPin } })
          }
        }
      } else {
        throw res
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.meta?.message ||
          error?.message ||
          error?.data?.message ||
          error?.data?.error?.message ||
          error?.error?.data?.meta?.error ||
          error?.error?.data?.message ||
          'Terjadi kesalahan',
        {
          variant: 'error',
        },
      )
    } finally {
      setIsAction(false)
    }
  }

  const onHandleSetPin = async (pin) => {
    setLoadingFetchOtp(true)
    try {
      await resetPin({
        identity: dataState?.identity,
        deviceHash: dataState?.hash ?? null,
        fcmToken: dataState?.fcmToken ?? '',
        packageName: dataState?.packageName || localStorage.getItem('PMB_packageName') || null,
        version: ` ${dataState?.mobileVersion ? `PM ${process.env.REACT_APP_VERSION} (${dataState?.mobileVersion})` : `PMB ${process.env.REACT_APP_VERSION}`} `,
        browserHash: browserHashLocalStorage ?? dataState?.browserHash,
        browserFingerPrint:
          browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
        browserCustomFingerPrint:
          browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
        'g-recaptcha-response': await recaptcha(),
        otp: otp,
        password: pin,
      })
      // setIsSetPin(false)
      enqueueSnackbar('Pin berhasil dibuat', { variant: 'success' })
      if (dataState?.navigateScreen) {
        window.location.replace(dataState?.navigateScreen)
      } else {
        navigate(-1)
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.meta?.message ||
          error?.message ||
          error?.data?.message ||
          error?.data?.error?.message ||
          error?.error?.data?.meta?.error ||
          error?.error?.data?.message ||
          'Terjadi kesalahan',
        {
          variant: 'error',
        },
      )
      setLoadingFetchOtp(false)
    } finally {
      setLoadingFetchOtp(false)
    }
  }

  const handleResend = async () => {
    try {
      const res = await sendOtp({
        identity: dataState?.identity,
        deviceHash: dataState?.hash ?? null,
        type: dataState?.status,
        channel: validateEmail(dataState?.identity) ? 'EMAIL' : 'WHATSAPP',
        browserHash: browserHashLocalStorage ?? dataState?.browserHash,
        browserFingerPrint:
          browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
        browserCustomFingerPrint:
          browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
        'g-recaptcha-response': await recaptcha(),
      })

      if (!res?.data?.meta?.error) {
        const newExpireTime = Number(res?.data?.data?.expireTime) || 60
        startCountdown(newExpireTime)
      } else {
        throw res
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.meta?.message ||
          error?.message ||
          error?.data?.message ||
          error?.data?.error?.message ||
          error?.error?.data?.meta?.error ||
          'Terjadi kesalahan',
        {
          variant: 'error',
        },
      )
    }
  }

  // useEffect(() => {
  //   if (token) {
  //     // dispatch(setIsV3(true))
  //     window.location.replace('/')
  //   }
  // }, [token])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCountdown((prevCountdown) => {
  //       if (prevCountdown <= 1) {
  //         clearInterval(interval)
  //         return 0
  //       }
  //       return prevCountdown - 1
  //     })
  //   }, 1000)

  //   return () => clearInterval(interval)
  // }, [])

  useEffect(() => {
    startCountdown(Number(dataState?.countDown) ?? 60)

    return () => {
      if (countdownInterval.current) {
        clearInterval(countdownInterval.current)
      }
    }
  }, [])

  return (
    <>
      <CardPin
        title={`Konfirmasi ${validateEmail(dataState?.identity) ? 'email' : 'nomor telepon'}`}
        desc={` Masukkan kode yang dikirim melalui${' '}
            ${validateEmail(dataState?.identity) ? 'email' : 'WhatsApp'} ke${' '}
            ${dataState?.identity}.`}
        length={5}
        isOtp
        handleResendOtp={handleResend}
        handleSubmit={handleSubmit}
        expireTime={countdown}
        loading={isAction}
        setErrMsg={setErrMsg}
        errMsg={errMsg}
        isWithPaste={true}
        testIdPrefix="otp"
      />
      <SetPinModal
        isOpen={isSetPin}
        onHandleSetPin={onHandleSetPin}
        isLoading={loadingFetchOtp}
        // isError={isError}
        onPressBack={() => setIsSetPin(false)}
      />
    </>
  )
}

export default Otp
